<template>
  <section>
    <b-modal width="680px" :active.sync="isNodeEditModalActive" :on-cancel="closeNodeEditModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">サイトマップ編集</span>
          </div>
        </header>
        <div class="card-content" style="border-radius: 5px; padding: 12px; text-align: left;">
          <span style="padding: 24px;">ドメイン以降のパスを入力してください</span>
          <b-field>
            <div class="split-box-form">
              <div class="split-box-left">
                <p>パス</p>
              </div>
              <div class="split-box-right">
                <input class="input is-small" placeholder="適用するパスを'/'から入力" v-model="editNodePath"/>
                <button class="button is-primary is-small" @click="returnEditSitemapNode" :disabled="!sitemapNodePath">更新</button>
              </div>
            </div>
          </b-field>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>

export default {
  name: 'ModalSitemapNodeEdit',
  componentName: 'ModalSitemapNodeEdit',
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isNodeEditModalActive: this.isSitemapNodeEditModalOpen,
      /** 編集ノードパス */
      editNodePath: '',
      initNodePath: ''
    }
  },
  props: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapNodeEditModalOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** サイトマップルートノード編集パス */
    sitemapNodePath: {
      type    : String,
      default : '',
      required: true
    }
  },
  watch: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapNodeEditModalOpen () {
      this.isNodeEditModalActive = this.isSitemapNodeEditModalOpen
    },
    sitemapNodePath () {
      this.editNodePath = this.sitemapNodePath
      this.initNodePath = this.sitemapNodePath
    }
  },
  methods: {
    /** 編集後サイトマップノードパス返却 */
    returnEditSitemapNode () {
      this.$emit('returnEditSitemapNode', this.editNodePath, this.initNodePath)
      if (this.editNodePath === '') {
        // 次同じコンテンツを開いた時ように入れておく
        this.editNodePath = this.initNodePath
      }
    },
    /** サイトマップノード編集ダイアログクローズ */
    closeNodeEditModal () {
      this.$emit('closeNodeEditModal')
      if (this.editNodePath === '') {
        // 次同じコンテンツを開いた時ように入れておく
        this.editNodePath = this.initNodePath
      }
    }
  }
}
</script>

<style scoped>
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.split-box-form {
  width: 100%;
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
}
.split-box-left {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.split-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/users/sitemap/ModalSitemapNodeEdit.vue